export default __webpack_public_path__ + "static/media/elmer704.2ded9c83.jpg";